// ======================================================================
// File Name       : GroupAdminRelation
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Table, Form } from 'react-bootstrap';
import * as MessageTemplate from '../../constants/MessageTemplate';

class GroupAdminRelation extends Component {
  render() {
    const { editingUserGroupAdmin, isDetail, isShowMessageMaxRecord } = this.props;

    return (
      <Form.Group>
        <Col sm={12} className="margin-top-20 padding-left-right-clear">
          <Col sm={3}>所属管理ユーザー</Col>
          <Col sm={9} className="msg-error padding-right-clear bold">
            {isDetail && isShowMessageMaxRecord ? MessageTemplate.MSG_RESULT_OVER_MAX_RETURN_NUM : ''}
          </Col>
        </Col>
        <Col sm={12}>
          <Table striped hover className="margin-top-7 margin-bottom-0">
            <thead>
              <tr>
                <th>ユーザー名</th>
                <th>ログインID</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(editingUserGroupAdmin).map((userSecernId, index) => {
                const data = editingUserGroupAdmin[userSecernId];
                return (
                  <tr key={index}>
                    <td>{data.userName}</td>
                    <td>{data.loginId}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Form.Group>
    );
  }
}

GroupAdminRelation.propTypes = {
  editingUserGroupAdmin: PropTypes.shape().isRequired,
  authority: PropTypes.shape().isRequired,
};

export default GroupAdminRelation;
